/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type SocialWelfareProps = {
  submitProps: FormSubmitProps;
};

export default function SocialWelfare({ submitProps }: SocialWelfareProps) {
  const { handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Persönliche Angaben
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type={"radio"}
                name={"hasSocialWelfare"}
                question={
                  "Erhalten Sie Leistungen zum Lebensunterhalt, z.B. aus Sozialhilfe, Grundsicherung oder Eingliederungshilfe? (hier ist NICHT Arbeitslosengeld gemeint - dies können Sie später angeben)"
                }
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                    optionHintText:
                      "Wenn Sie Arbeitslosengeld I oder Arbeitslosengeld II (Hartz 4) bekommen oder unsicher sind, wählen Sie bitte „Nein“ aus. Welche Art von Leistungen Sie erhalten, können Sie Ihrem Bescheid entnehmen.",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
